module.exports = __webpack_public_path__ + "img/mobilePhoneBlue.769c146a.png";